/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @nx/enforce-module-boundaries */
import { HttpClient } from '@angular/common/http';
import { UntypedFormControl } from '@angular/forms';
import { BigFormService, Flow_0_0_2, getAllInfo, getFullItemOne, getSelectedItemOne, getSelectedItemTwo } from '@flexus/core';
import { Store } from '@ngrx/store';
import { CollapseActionPanel, setActionPanelItems } from '../../../../app-shell-features';
import { environment } from 'apps/studio/src/environments/environment';
import { filter, map, mergeMap, switchMap, take } from 'rxjs';
import { PGG_BANK_DETAILS } from '.';
import { jobInfoNode } from '../reusable/JOB_INFO_NODE';

export const PGG_265: Flow_0_0_2 = {
	id: '265',
	name: 'refund_failed_confirm_bank_account',
	itemType: 'flow',
	actionPanel: (instance: any) => setActionPanelItems(instance, ['installation-summary', 'documents'],{ useDynamicTab: true }),
	onStateInit: (inst: any) => {
		inst.store.dispatch(new CollapseActionPanel());
	},
	onStateDestroy: (inst: any) => {
		inst.store.dispatch(new CollapseActionPanel());
	},
	header: {
		title: (store: any) => {
			return store.select(getFullItemOne).pipe(
				filter(Boolean),
				take(1),
				map((itemOne: any) => {
					let headingstring = 'Refund Failed - Confirm Bank Account';
					if (itemOne) {
						const uniqueClaimRef = itemOne?.loan_information?.voucher_key ?? itemOne?.mid;
						if (uniqueClaimRef) {
							headingstring += ` :  ${uniqueClaimRef} - ${itemOne?.applicant?.first_name}`;
						}
					}
					return headingstring;
				})
			);
		},
		controls: () => () => []
	},

	footer: {
		type: 'node_nav'
	},
	serverCalls: {
		accountTypes: {
			errorMessage: 'Could not get account types!',
			directCall: (http: any, store: any) => {
				return store.select(getAllInfo).pipe(
					//pluck('account_type'),
					filter(Boolean),
					take(1),
					map((response: any) => response.account_type)
				);
			}
		}
	},
	instructions: {
		editRoles: {
			0: 'Confirm refund payment success'
		},
		viewRoles: {
			0: 'Refund payment being confirmed'
		}
	},
	startNode: 'DamagedStockStatusVerification',

	nodes: {
		DamagedStockStatusVerification: {
			...jobInfoNode(265, 'Refund Failed', ['The customer has not acknowledged that the refund failed.', 'Contact the customer to confirm the status.']),
			navs: [
				{
					text: 're-enter bank details',
					color: 'primary',
					linkType: 'portal',
					nextNode: 'BankDetailsCapture'
				}
			]
		},
		BankDetailsCapture: {
			component: 'PggBankDetailsTemplateComponent',
			inputs: {
				accountType$: 'accountTypes'
			},
			...PGG_BANK_DETAILS,
			navs: [
				{
					text: 'submit',
					color: 'primary',
					linkType: 'submit',
					nextNode: 'SubmissionSuccess',
					serverFirst: true,
					serverCalls: {
						response: {
							errorMessage: '',
							directCall: (_http: HttpClient, _store: Store, sq: any, _bf: BigFormService) => {
								_bf.addControl('new_state', new UntypedFormControl(266));
								return _store.select(getSelectedItemOne).pipe(
									filter(Boolean),
									take(1),
									mergeMap((data: any) => {
										const claim = data;
										const { id } = claim;
										const formcontrol = _bf.getControl('bank_details');
										const account_holder_name = formcontrol.get('account_holder_name').value;
										const account_number = formcontrol.get('account_number').value;
										const account_type = formcontrol.get('account_type').value.toLowerCase();
										const bank_name = formcontrol.get('bank_name').value;
										return _http.post(`${environment.api_url}v1/refund_action/modify_bank_details/`, {
											application_id: id,
											account_holder: account_holder_name,
											account_type: account_type,
											bank_name: bank_name,
											account_number: account_number
										});
									})
								);
							},
							followUpSuccessCalls: {
								updateJob: {
									errorMessage: 'Could not update job!',
									directCall: (_http: HttpClient, _store: Store, _sq: any, _bf: BigFormService) => {
										return _store.select(getSelectedItemTwo).pipe(
											filter(Boolean),
											take(1),
											switchMap((job: any) => {
												const job_id = job?.id;
												const new_state = _bf.getControl('new_state').value;
												return _http.post(`${environment.api_url}v1/job_action/update_job/`, { job_id: job_id, new_state: new_state });
											})
										);
									}
								}
							}
						}
					}
				}
			]
		},
		SubmissionSuccess: {
			component: 'FLXSuccessTickComponent'
		}
	}
};
